/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unneeded-ternary */
import { createEvent, createStore } from 'effector';
export const setShowBoxDetails = createEvent();
export const handleCase = createEvent();
export const showBoxDetails = createStore(false).on(setShowBoxDetails, currentState => !currentState);
export const caseDetails = createStore(null).on(handleCase, (_, payload) => payload);
